export enum InputPreset {
  COMPACT,
  NORMAL
}
